module.exports = __webpack_public_path__ + "static/img/voc_brand_logo_white.0cc8aa.png";